export const TableBody = ({children}) => {

    return(
        <tbody>
            {children}
        </tbody>
    )
}